<template>
  <a-card class="m-display-flex flex-column nowrap">
    <span slot="title">Create Overbooking</span>
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      class="steps-content m-flex1"
    >
      <!-- <a-row :gutter="16">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }"> -->
      <a-form-model-item label="Date" prop="date">
        <a-input v-model="form.date" :disabled="true"></a-input>
      </a-form-model-item>
      <a-form-model-item label="Account From" prop="account_from">
        <a-select
          showSearch
          placeholder="Please select"
          :filter-option="filterOption"
          v-model="form.account_from"
          @change="handleChangeAF"
        >
          <a-select-option v-for="item in list_bank_from" :key="item.value">
            {{ item.text }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item prop="value">
        <span slot="label">Value</span>
        <a-input-number
          type="number"
          class="m-width-full m-text-align right"
          :formatter="
            (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          "
          :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
          v-model="form.value"
        />
      </a-form-model-item>

      <a-form-model-item prop="kurs">
        <span slot="label">Kurs</span>
        <a-input-number
          type="number"
          class="m-width-full m-text-align right"
          :formatter="
            (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          "
          :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
          v-model="form.kurs"
        />
      </a-form-model-item>

      <!-- <a-form-model-item label="Currency" prop="currency_from">
            <a-select
              showSearch
              placeholder="Please select"
              v-model="form.currency_from"
              :disabled="disabledCurrFrom"
            >
              <a-select-option
                v-for="item in list_currency"
                :key="item.value"
                :value="item.value"
                >{{ item.text }}</a-select-option
              >
            </a-select>
          </a-form-model-item> -->
      <!-- </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }"> -->
      <a-form-model-item label="Account To" prop="account_to">
        <a-select
          showSearch
          placeholder="Please select"
          :filter-option="filterOption"
          v-model="form.account_to"
          @change="handleChangeAccountTo"
        >
          <a-select-option v-for="item in list_bank" :key="item.value">
            {{ item.text }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- <a-form-model-item label="Currency" prop="currency_to">
            <a-select
              showSearch
              placeholder="Please select"
              disabled
              v-model="form.currency_to"
            >
              <a-select-option
                v-for="item in list_currency"
                :key="item.value"
                :value="item.value"
                >{{ item.text }} </a-select-option
              >
            </a-select> 
          </a-form-model-item>-->

      <a-form-model-item label="Description" prop="description">
        <a-textarea
          placeholder="Write the description here ... "
          :rows="1"
          v-model="form.description"
        />
      </a-form-model-item>

      <a-form-model-item label="Upload File Support" prop="upload_file">
            <a-upload
              :showUploadList="true"
              :fileList="push"
              :beforeUpload="beforeUpload"
              :remove="handleRemove"
              v-model="form.upload_file"
            >
              <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
            </a-upload>
          </a-form-model-item>
      <!-- </a-col>
      </a-row> -->
    </a-form-model>

    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button
          type="primary"
          :loading="loading.submit"
          @click="handleValidation"
        >
          Save
        </a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "AccountMutation",
  props: ["id"],
  mixins: [GlobalMethod, CurrencyFormat],
  data() {
    let validatePass = (rule, value, callback) => {
      if (this.push.length == 0) {
        callback(new Error("Please input the file"));
      } else {
        callback();
      }
    };
    return {
      disabledCurrFrom: true,
      loading: {
        submit: false,
      },
      list_bank: [],
      list_bank_from: [],
      list_currency: [],
      push: [],
      form: {
        date: moment().format("DD-MM-YYYY"),
        value: 1,
        kurs: 1,
      },
      rules: {
        date: [
          {
            required: true,
            message: "Please Select date",
            trigger: "change",
          },
        ],
        account_from: [
          {
            required: true,
            message: "Please Select Account From",
            trigger: "change",
          },
        ],
        currency_from: [
          {
            required: true,
            message: "Please Select Currency From",
            trigger: "change",
          },
        ],
        value: [
          {
            required: true,
            message: "Please Input Value",
            trigger: "change",
          },
        ],
        kurs: [
          {
            required: true,
            message: "Please Kurs Value",
            trigger: "change",
          },
        ],
        account_to: [
          {
            required: true,
            message: "Please Select Account to",
            trigger: "change",
          },
        ],
        currency_to: [
          {
            required: true,
            message: "Please Select Currency to",
            trigger: "change",
          },
        ],
        description: [
          {
            required: true,
            message: "Please Input Description",
            trigger: "change",
          },
        ],
        upload_file: [
          {
            required: false,
            //validator: validatePass,
            message: "Please select file",
            trigger: "change",
          },
        ],
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getAllMataUang",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
  },
  methods: {
    moment,
    fetchdata() {
      axios({
        method: "get",
        url: this.$serviceUrl + "account_mutation/data_input",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          // this.list_bank = _.filter(
          //   response.data.bank_account,
          //   (item) => item.currency.indexOf("IDR") >= 0
          // );
          this.list_bank =  response.data.bank_account;
          this.list_bank_from = response.data.bank_account;
          this.list_currency = response.data.currency;
        })
        .catch((err) => {
          let response = Object.assign({}, err.response.data);
          if (response.status == false) {
            this.displayMessageValue("error-other", response.message);
          } else {
            this.displayMessageValue("error", err);
          }
        });
    },
    handleValidation() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
        if (this.form.account_from == this.form.account_to) {
          this.displayMessageValue(
            "error-other",
            "Account to Can't be same with Account From!"
          );
          return;
        }
        this.confirmMessage("confirm-save");
      });
    },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        let postData = new FormData();
        postData.append("account_from", this.form.account_from);
        postData.append("account_to", this.form.account_to);
        // postData.append("currency_from", this.form.currency_from);
        // postData.append("currency_to", this.form.currency_to);
        postData.append("date", moment().format(this.getStandartFormatDate));
        postData.append("description", this.form.description);
        if(this.push && this.push.length>0)
          postData.append("upload_file_support", this.push[0]);
        postData.append("value", this.form.value);
        postData.append("kurs", this.form.kurs);
        postData.append("tlc", this.getAuth.username);

        this.loading.submit = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "account_mutation",
          data: postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then(() => {
            this.displayMessage("success-save");
            this.$router.push({ name: "AccountMutationIndexKeu" });
          })
          .catch((err) => {
            this.loading.submit = false;
            let response = Object.assign({}, err.response.data);
            if (response.status == false) {
              this.displayMessageValue("error-other", response.message);
            } else {
              this.displayMessageValue("error", err);
            }
          });
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      // let extension =
      //   file.name.substr(file.name.lastIndexOf(".")) == ".xls" ||
      //   file.name.substr(file.name.lastIndexOf(".")) == ".xlsx";
      // if (extension) {
      if (FileSize > 30) {
        this.displayMessage("large-file-2mb");
      } else {
        this.push = [file];
        return false;
      }
      // } else {
      //   this.displayMessage("error-formatXls");
      // }
    },
    handleRemove() {
      this.push = [];
    },
    handleChangeAccountTo(item) {
      let filter = _.filter(this.list_bank, { value: item });
      if (filter.length > 0) {
        this.form.currency_to = filter[0].currency;
      }
    },
    handleChangeAF(item) {
      if (item) {
        let t_emp = _.filter(this.list_bank, { value: item });
        if (t_emp[0].currency == "") {
          this.disabledCurrFrom = false;
          this.form.currency_from = undefined;
        } else {
          this.disabledCurrFrom = true;
          this.form.currency_from = t_emp[0].currency;
        }
      }
    },
  },

  mounted() {
    this.fetchdata();
    Event.$on("confirmMessageReturn", this.submit);
    Event.$on("handleChildValue", this.handleChildValue);
  },

  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.submit);
    Event.$off("handleChildValue", this.handleChildValue);
  },
};
</script>

<style lang="less">
.step {
  border: 1px solid darken(white, 10);
  flex: 1;
  display: flex;
  flex-direction: column;
  &-header {
    padding: @padding;
    background-color: darken(white, 2);
    border-bottom: 1px solid darken(white, 10);
  }
  &-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.padding-unset {
  .ant-card-body {
    padding: 0 !important;
  }
}

.ant-card-extra {
  margin-left: 0px !important;
}
</style>
